module.exports = __webpack_public_path__ + "img/team-3.298f127b.jpg";